import styled, { css } from "styled-components";

export const ModalTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  border-bottom: 1px solid #ccc;

  h1 {
    font-size: 17px;
    line-height: 28px;
    font-weight: bold;
  }

  svg {
    width: 18px;
    height: 18px;
    fill: #ccc;
    cursor: pointer;
    margin-bottom: 4px;
  }
`;

export const CreditCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  max-height: 500px;
  min-height: 220px;
  padding: 10px;
  background: ${(props) =>
    props.v2 ? "url('/images/bg-card.png') no-repeat center" : "#f5f5f5"};
  background-size: cover;
  font-weight: 700;
  border-radius: 10px;
  border: 1px solid #b2bec3;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 15px;

  position: relative;

  .logo-bottom {
    position: absolute;
    bottom: 20px;
    right: 14px;
  }
`;

export const CreditCardTitle = styled.div`
  display: flex;
  width: 100%;
  height: 30px;
  border-bottom: 1px solid ${(props) => (props.v2 ? "transparent" : "#f0f0f0")};
  padding-bottom: 5px;
  margin-bottom: 25px;

  span {
    margin-right: 10px;
  }
  & > span:nth-child(1) {
    color: #52c41a;
    border: 1px solid #52c41a;
    padding: 5px;
    display: flex;
    justify-items: center;
    align-content: center;
    align-items: center;
    justify-content: center;

    ${(props) =>
      props.v2 &&
      css`
        display: flex;
        padding: 1px 8px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 16px;
        border: 1px solid var(--status-color-success, #52c41a);
        background: #52c41a;
        color: #fff;
        /* Footnote 12/description */
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;

        &.bloqueado{
          border-color: #FF4D4F;
          background: #FF4D4F;
          padding: 1px 7px;
        }
      `}
  }

  & > button:nth-child(2) {
    background: #fa8c16;
    color: #fff;
    border: 1px solid #fa8c16;
    padding: 5px;
    display: flex;
    justify-items: center;
    cursor: pointer;
    align-content: center;
    align-items: center;
    justify-content: center;
    ${(props) =>
      props.v2 &&
      css`
        display: flex;
        padding: 1px 24px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        background: var(--brand-color-gold-6, #5188F4);
        /* drop-shadow/button-primary */
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
          color: var(--neutral-color-gray-9, #434343);
        text-align: center;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
      `}
  }
  & > button:nth-child(3) {
    background: #1890ff;
    color: #fff;
    border: 1px solid #1890ff;
    padding: 5px;
    display: flex;
    justify-items: center;
    cursor: pointer;
    align-content: center;
    align-items: center;
    justify-content: center;
  }
`;
export const CreditCardTitleMoreOption = styled.div`
  display: flex;
  width: 20%;
  flex: 1;
  justify-content: flex-end;
  align-content: center;
  justify-items: center;

  span {
    font-weight: 700;
    font-size: 13px;
    cursor: pointer;
  }
`;

export const CreditCardBody = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
`;

export const CreditCardRow = styled.div`
  margin: 5px 0;
  max-width: 100%;
  word-wrap: break-word;
  display: ${(props) => (props.v2 ? "flex" : "block")};
  flex-wrap: ${(props) => (props.v2 ? "wrap" : "inherit")};

  span {
    margin: 0 5px;
    color: ${(props) => (props.v2 ? "#fff" : "#000")};
  }

  .left-credit-card {
    width: calc(100% - 100px);
    display: flex;
    flex-direction: column;
  }

  .right-credit-card {
    width: 100px;

    .new-status-card-physical,
    .new-status-card-virt {
      display: flex;
      padding: 1px 8px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 16px;
      border: 1px solid var(--status-color-info, #1890ff);
      background: rgba(24, 144, 255, 0.05);

      color: var(--status-color-info, #1890ff);
      /* Footnote 12/description */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    .new-status-card-embossing {
      display: flex;
      padding: 1px 8px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      margin-top: 8px;
      border-radius: 16px;
      border: 1px solid var(--neutral-color-gray-1, #fff);
      color: var(--neutral-color-gray-1, #fff);
      /* Footnote 12/description */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }

  .credit-card-physical {
    margin-left: 15px;
    background: #e6f7ff;
    color: #1890ff;
    border: 1px solid #1890ff;
    padding: 2px;
    font-size: 10px;
  }

  .credit-card-embossing {
    margin-left: 250px;
    background: #f5f5f5;
    color: #6f5f4f;
    border: 0.5px solid #6f5f4f;
    padding: 2px;
    font-size: 10px;
  }

  .credit-card-virt {
    margin-left: 15px;
    background: #e6f7ff;
    color: #52c41a;
    border: 1px solid #52c41a;
    padding: 2px;
    font-size: 10px;
  }
`;

export const WrapperSelectBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
  span {
    margin-bottom: 5px;
  }

  h2 {
    width: 100%;
    text-align: center;
    font-weight: 700;
  }
  h3 {
    width: 100%;
    text-align: center;
    background: #fa8c16;
    color: #fff;
    border-radius: 10px;
    padding: 5px 0;
  }

  .solicitate {
    background: #fa8c16;
    border: none;
    padding: .3rem;
    border-radius: 5px;
  }
`;

export const ListDescription = styled.div`
  span {
    margin-right: 5px;
  }
`;
export const ListDate = styled.div`
  span {
    margin-right: 5px;
  }
`;
export const TypeBlock = styled.div`
  span {
    margin-right: 5px;
  }
`;

export const ModalRow = styled.div`
  display: flex;
  align-content: space-around;
  justify-content: space-around;
  margin-top: 10px;

  .center{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btns-send {
    width: 100%;

    display: flex;
    justify-content: flex-end;

    button {
      padding: 8px 24px;

      background: #5188F4;
      color: #fff;
      border: 1px solid #bfbfbf;
      box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);
      border-radius: 2px;
      font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      text-align: center;

      &:first-of-type {
        margin-right: 5px;
        background: #ffffff;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
`;

export const ModalRowWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: space-between;
  margin-top: 10px;

  .error-message {
    text-align: right;
    font-size: 12px;
    color: #ff4d4f;
  }
`;

export const inputNameFull = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    width: 60%;
  }
`;

export const inputCreditCard = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 38%;
  }
`;

export const inputW50 = styled.div`
  width: 100%;

  p.title {
    padding: 0;
    margin: 0;
    margin-bottom: 8px;

    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #272d3b;

    span {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #ff4d4f;
      margin-right: 5px;
    }
  }

  .grau-card {
    .ant-select-selector {
      height: 40px;
      padding: 4px 12px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
    }

    &.error-id {
      border: 1px solid #ff4d4f;
    }
  }

  @media (min-width: 768px) {
    width: 49%;
  }
`;

export const inputW33 = styled.div`
  width: 100%;
  position: relative;

  .input-cep {
    position: relative;
  }

  p.title {
    padding: 0;
    margin: 0;
    margin-bottom: 8px;

    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #272d3b;

    span {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #ff4d4f;
      margin-right: 5px;
    }
  }

  .spinner {
    position: absolute;
    top: 41px;
    right: 5px;
    visibility: hidden;
    transform: translate3d(0, -10px, 0);

    &.active {
      visibility: inherit;
      transition: 0.3s;
      transform: translate3d(0px, 0, 0);
    }

    svg {
      animation: spinnerAction 1s infinite linear;
    }
  }

  @-webkit-keyframes spinnerAction {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spinnerAction {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (min-width: 768px) {
    width: 32%;
  }

  .grau-card {
    .ant-select-selector .ant-select-selection-search .ant-select-selection-search-input {
      height: 40px;
      padding: 4px 0px;
    }

    .ant-select-selector {
      height: 40px;
      padding: 4px 12px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
    }
  }
`;

export const inputW40 = styled.div`
  width: 100%;

  p.title {
    padding: 0;
    margin: 0;
    margin-bottom: 8px;

    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #272d3b;

    span {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #ff4d4f;
      margin-right: 5px;
    }
  }

  .grau-card {
    .ant-select-selector {
      height: 40px;
      padding: 4px 12px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
    }

    &.error-id {
      border: 1px solid #ff4d4f;
    }
  }

  @media (min-width: 768px) {
    width: 39%;
  }
`;

export const inputW20 = styled.div`
  width: 100%;

  p.title {
    padding: 0;
    margin: 0;
    margin-bottom: 8px;

    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #272d3b;

    span {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #ff4d4f;
      margin-right: 5px;
    }
  }

  @media (min-width: 768px) {
    width: 19%;
  }
`;

export const grayItems = styled.div`
  width: 100%;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 16px;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .item-gray {
    width: 49%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      padding: 0;
      margin: 0;
    }
  }
`;

export const InformationCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 700px;
  padding: 10px;
  background: #f5f5f5;
  font-weight: 700;
  border-radius: 10px;
  border: 1px solid #b2bec3;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 15px;

  b {
    font-weight: 700;
  }
`;

export const ModalAddWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  .ant-input-group-wrapper {
    margin-right: 5px;
  }
`;

export const ContainerSelect = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-right: 5px;
`;

export const WrapperButtonsReset = styled.div`
  display: flex;
  justify-content: space-around;
  align-content: space-around;
`;

export const WrapperNewLoading = styled.div`
  width: 100%;
  min-height: 20vh;
  /* height: 100vh; */
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NewLoadingModals = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const HistoryListItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  width: 100%;
  margin-bottom: ${props => props.isLast ? '0' : '36px'};
`;

export const TimelineContainer = styled.div`
  width: 100%;
  border-left: 3px solid #d9d9d9;
  padding-left: 16px;
`;

export const BlockSection = styled.div`
  width: 100%;
  margin-bottom: ${props => props.isLast ? '0' : '16px'};
`;

export const BlockHeader = styled.h4`
  color: #8C8C8C;
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 14px;
`;

export const DataGrid = styled.div`
  display: grid;
  grid-template-columns: 170px 1fr;
  row-gap: 4px;
  width: 100%;
  font-size: 13px;
`;

export const GridLabel = styled.span`
  font-weight: bold;
  color: #333;
`;

export const GridValue = styled.span`
  color: #555;
`;